import React from 'react';
import FootballMatchList from './FootballMatchList';
import { mapMatchesToCompetitionRounds } from 'modules/Football/utils';
import PropTypes from 'prop-types';

export default function FootballMatchRoundList({ matchList = [], ...rest }) {
    require('./FootballMatchRoundList.scss');
    const groupedMatches = mapMatchesToCompetitionRounds(matchList);

    function getRoundName(round) {
        if (!round || !round.round_type) {
            return '';
        }

        return round.round_type == "Round" ? `${round.round_type} ${round.round_number}` : round.round_type;
    }

    function renderRoundHeader(round) {
        // Do not display the round header if we have no round or the round === 1
        // (If we dont exclude Round 1 we display it for all cup competition group stage matches)
        if (!round || (round.round_type == "Round" && round.round_number === 1)) {
            return null;
        }

        const name = getRoundName(round);
        if (!name || name.length == 0) {
            return null;
        }

        return <h4 className="round-title">{name}</h4>
    }

    function renderRoundList({round, matchList}) {
        const header = renderRoundHeader(round);
        const name = getRoundName(round);
        return (
            <div key={name} className="round-list">
                {header}
                <FootballMatchList matchList={matchList} {...rest}></FootballMatchList>
            </div>
        );
    }

    if (!groupedMatches || groupedMatches.size === 0) {
        return null;
    }

    const rounds = [];
    groupedMatches.forEach((round) => {
        rounds.push(renderRoundList(round));
    });

    return <div>{rounds}</div>;
}

FootballMatchRoundList.propTypes = {
    matchList: PropTypes.array
}


// WEBPACK FOOTER //
// ./modules/Football/components/FootballMatchRoundList.js